import Gear from './src/pages/ItemSaga/Gear';
import GearUpdate from './src/pages/ItemSaga/Gear/GearUpdate';
import GearCreate from './src/pages/ItemSaga/Gear/GearCreate';
import Artifact from './src/pages/ItemSaga/Artifact';
import ArtifactUpdate from './src/pages/ItemSaga/Artifact/ArtifactUpdate';
import ArtifactCreate from './src/pages/ItemSaga/Artifact/ArtifactCreate';
import HeroSkin from './src/pages/ItemSaga/HeroSkin';
import HeroSkinUpdate from './src/pages/ItemSaga/HeroSkin/HeroSkinUpdate';
import HeroSkinCreate from './src/pages/ItemSaga/HeroSkin/HeroSkinCreate';
import DiceSkin from './src/pages/ItemSaga/DiceSkin';
import DiceSkinUpdate from './src/pages/ItemSaga/DiceSkin/DiceSkinUpdate';
import DiceSkinCreate from './src/pages/ItemSaga/DiceSkin/DiceSkinCreate';
import CardSkin from './src/pages/ItemSaga/CardSkin';
import CardSkinUpdate from './src/pages/ItemSaga/CardSkin/CardSkinUpdate';
import CardSkinCreate from './src/pages/ItemSaga/CardSkin/CardSkinCreate';
import Emote from './src/pages/ItemSaga/Emote';
import EmoteUpdate from './src/pages/ItemSaga/Emote/EmoteUpdate';
import EmoteCreate from './src/pages/ItemSaga/Emote/EmoteCreate';
import PlayerIcon from './src/pages/ItemSaga/PlayerIcon';
import PlayerIconUpdate from './src/pages/ItemSaga/PlayerIcon/PlayerIconUpdate';
import PlayerIconCreate from './src/pages/ItemSaga/PlayerIcon/PlayerIconCreate';
import Consumable from './src/pages/ItemSaga/Consumable';
import ConsumableUpdate from './src/pages/ItemSaga/Consumable/ConsumableUpdate';
import ConsumableCreate from './src/pages/ItemSaga/Consumable/ConsumableCreate';
import Reward from './src/pages/ItemSaga/Reward';
import RewardUpdate from './src/pages/ItemSaga/Reward/RewardUpdate';
import RewardCreate from './src/pages/ItemSaga/Reward/RewardCreate';
import Item from './src/pages/ItemSaga/Item';
import ItemUpdate from './src/pages/ItemSaga/Item/ItemUpdate';
import ItemCreate from './src/pages/ItemSaga/Item/ItemCreate';
import LootBox from './src/pages/ItemSaga/LootBox';
import LootBoxUpdate from './src/pages/ItemSaga/LootBox/LootBoxUpdate';
import LootBoxCreate from './src/pages/ItemSaga/LootBox/LootBoxCreate';
import SwapEffect from './src/pages/ItemSaga/SwapEffect';
import SwapEffectUpdate from './src/pages/ItemSaga/SwapEffect/SwapEffectUpdate';
import SwapEffectCreate from './src/pages/ItemSaga/SwapEffect/SwapEffectCreate';

const MenuItemSaga = [
    {
        id: 'gear',
        name: 'Gear',
        icon: 'icon-chemistry',
        path: 'gear',
        component: Gear,
        isShown: 1,
    },
    {
        path: 'gear/create',
        name: 'Gear > Create',
        component: GearCreate,
        isShown: 0,
    },
    {
        path: 'gear/update/:id',
        name: 'Gear > Update',
        component: GearUpdate,
        isShown: 0,
    },
    {
        id: 'swap-effect',
        name: 'SwapEffect',
        icon: 'icon-chemistry',
        path: 'swap-effect',
        component: SwapEffect,
        isShown: 1,
    },
    {
        path: 'swap-effect/create',
        name: 'SwapEffect > Create',
        component: SwapEffectCreate,
        isShown: 0,
    },
    {
        path: 'swap-effect/update/:id',
        name: 'SwapEffect > Update',
        component: SwapEffectUpdate,
        isShown: 0,
    },
    {
        id: 'artifact',
        name: 'Artifact',
        icon: 'icon-chemistry',
        path: 'artifact',
        component: Artifact,
        isShown: 1,
    },
    {
        path: 'artifact/create',
        name: 'Artifact > Create',
        component: ArtifactCreate,
        isShown: 0,
    },
    {
        path: 'artifact/update/:id',
        name: 'Artifact > Update',
        component: ArtifactUpdate,
        isShown: 0,
    },
    {
        id: 'heroSkin',
        name: 'Hero Skin',
        icon: 'icon-chemistry',
        path: 'hero-skin',
        component: HeroSkin,
        isShown: 1,
    },
    {
        path: 'hero-skin/create',
        name: 'HeroSkin > Create',
        component: HeroSkinCreate,
        isShown: 0,
    },
    {
        path: 'hero-skin/update/:id',
        name: 'HeroSkin > Update',
        component: HeroSkinUpdate,
        isShown: 0,
    },
    {
        id: 'diceSkin',
        name: 'Dice Skin',
        icon: 'icon-chemistry',
        path: 'dice-skin',
        component: DiceSkin,
        isShown: 1,
    },
    {
        path: 'dice-skin/create',
        name: 'DiceSkin > Create',
        component: DiceSkinCreate,
        isShown: 0,
    },
    {
        path: 'dice-skin/update/:id',
        name: 'DiceSkin > Update',
        component: DiceSkinUpdate,
        isShown: 0,
    },
    {
        id: 'cardSkin',
        name: 'Card Skin',
        icon: 'icon-chemistry',
        path: 'card-skin',
        component: CardSkin,
        isShown: 1,
    },
    {
        path: 'card-skin/create',
        name: 'CardSkin > Create',
        component: CardSkinCreate,
        isShown: 0,
    },
    {
        path: 'card-skin/update/:id',
        name: 'CardSkin > Update',
        component: CardSkinUpdate,
        isShown: 0,
    },
    {
        id: 'emote',
        name: 'Emote',
        icon: 'icon-chemistry',
        path: 'emote',
        component: Emote,
        isShown: 1,
    },
    {
        path: 'emote/create',
        name: 'Emote > Create',
        component: EmoteCreate,
        isShown: 0,
    },
    {
        path: 'emote/update/:id',
        name: 'Emote > Update',
        component: EmoteUpdate,
        isShown: 0,
    },
    {
        id: 'playerIcon',
        name: 'Player Icon',
        icon: 'icon-chemistry',
        path: 'player-icon',
        component: PlayerIcon,
        isShown: 1,
    },
    {
        path: 'player-icon/create',
        name: 'PlayerIcon > Create',
        component: PlayerIconCreate,
        isShown: 0,
    },
    {
        path: 'player-icon/update/:id',
        name: 'PlayerIcon > Update',
        component: PlayerIconUpdate,
        isShown: 0,
    },
    {
        id: 'consumable',
        name: 'Consumable',
        icon: 'icon-event',
        path: 'consumable',
        component: Consumable,
        isShown: 1,
    },
    {
        path: 'consumable/create',
        name: 'Consumable > Create',
        component: ConsumableCreate,
        isShown: 0,
    },
    {
        path: 'consumable/update/:id',
        name: 'Consumable > Update',
        component: ConsumableUpdate,
        isShown: 0,
    },
    {
        id: 'item',
        name: 'Item',
        icon: 'icon-event',
        path: 'item',
        component: Item,
        isShown: 1,
    },
    {
        path: 'item/create',
        name: 'Item > Create',
        component: ItemCreate,
        isShown: 0,
    },
    {
        path: 'item/update/:id',
        name: 'Item > Update',
        component: ItemUpdate,
        isShown: 0,
    },
    {
        id: 'reward',
        name: 'Reward',
        icon: 'icon-event',
        path: 'reward',
        component: Reward,
        isShown: 1,
    },
    {
        path: 'reward/create',
        name: 'Reward > Create',
        component: RewardCreate,
        isShown: 0,
    },
    {
        path: 'reward/update/:id',
        name: 'Reward > Update',
        component: RewardUpdate,
        isShown: 0,
    },
    {
        id: 'loot-box',
        name: 'Loot Box',
        icon: 'icon-event',
        path: 'loot-box',
        component: LootBox,
        isShown: 1,
    },
    {
        path: 'loot-box/create',
        name: 'LootBox > Create',
        component: LootBoxCreate,
        isShown: 0,
    },
    {
        path: 'loot-box/update/:id',
        name: 'LootBox > Update',
        component: LootBoxUpdate,
        isShown: 0,
    },
];

export default MenuItemSaga;
